// Author Lidongxu
// Date 2025-06-03 13:04:53

class EmStocktakingTask {
    constructor({
                    id = null,
                    taskCode = '',
                    taskBusinessType = '',
                    taskHandlerId = '',
                    stocktakeStatus = '',
                    taskCreatedTime = '',
                    firstStocktakeTime = '',
                    finishStocktakeTime = '',
                    remark = ''
                }
                = {}) {
        this.id = id;
        this.taskCode = taskCode;
        this.taskBusinessType = taskBusinessType;
        this.taskHandlerId = taskHandlerId;
        this.stocktakeStatus = stocktakeStatus;
        this.taskCreatedTime = taskCreatedTime;
        this.firstStocktakeTime = firstStocktakeTime;
        this.finishStocktakeTime = finishStocktakeTime;
        this.remark = remark;
    }
}

function newEntity() {
    return new EmStocktakingTask();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.archive.emStocktakingTask.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'taskCode',
            label: 'label.em.archive.emStocktakingTask.grid.taskCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'taskBusinessType',
            label: 'label.em.archive.emStocktakingTask.grid.taskBusinessType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '工具/刀具'},
                    {value: '2', text: '吊索具'},
                    {value: '3', text: '固定资产'},
                    {value: '4', text: '工装'}, {value: '5', text: '量器具'}
                ]
            }
        },
        {
            key: 'taskHandlerId',
            label: 'label.em.archive.emStocktakingTask.grid.taskHandlerId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'taskHandler',
            label: 'label.em.archive.emStocktakingTask.grid.taskHandler',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'stocktakeStatus',
            label: 'label.em.archive.emStocktakingTask.grid.stocktakeStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: '未盘点'},
                    {value: '1', text: '盘点中'},
                    {value: '2', text: '部分盘点'},
                    {value: '3', text: '盘点成功完成'},
                    {value: '4', text: '补盘点成功完成'},
                    {value: '5', text: '盘点异常完成'}
                ]
            }
        },
        {
            key: 'taskCreatedTime',
            label: 'label.em.archive.emStocktakingTask.grid.taskCreatedTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'firstStocktakeTime',
            label: 'label.em.archive.emStocktakingTask.grid.firstStocktakeTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'finishStocktakeTime',
            label: 'label.em.archive.emStocktakingTask.grid.finishStocktakeTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.archive.emStocktakingTask.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    taskCodeFilter: '',
    taskBusinessTypeFilter: '',
    taskHandlerIdFilter: '',
    stocktakeStatusFilter: '',
    taskCreatedTimeRteFilter: '',
    taskCreatedTimeLteFilter: '',
    firstStocktakeTimeRteFilter: '',
    firstStocktakeTimeLteFilter: '',
    finishStocktakeTimeRteFilter: '',
    finishStocktakeTimeLteFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'taskCodeFilter',
        label: 'label.em.archive.emStocktakingTask.filter.taskCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'taskBusinessTypeFilter',
        label: 'label.em.archive.emStocktakingTask.filter.taskBusinessType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '工具/刀具'},
                {value: '2', text: '吊索具'},
                {value: '3', text: '固定资产'},
                {value: '4', text: '工装'}, {value: '5', text: '量器具'}
            ]
        }
    },
    {
        key: 'taskHandlerIdFilter',
        label: 'label.em.archive.emStocktakingTask.filter.taskHandlerId',
        disabled: false,
        form: {
            type: 'entityModalMultipleSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
        }
    },
    {
        key: 'stocktakeStatusFilter',
        label: 'label.em.archive.emStocktakingTask.filter.stocktakeStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '未盘点'},
                {value: '1', text: '盘点中'},
                {value: '2', text: '部分盘点'},
                {value: '3', text: '盘点成功完成'},
                {value: '4', text: '补盘点成功完成'},
                {value: '5', text: '盘点异常完成'}
            ]
        }
    },
    {
        key: 'taskCreatedTimeRteFilter',
        label: 'label.em.archive.emStocktakingTask.filter.taskCreatedTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'taskCreatedTimeLteFilter',
        label: 'label.em.archive.emStocktakingTask.filter.taskCreatedTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'firstStocktakeTimeRteFilter',
        label: 'label.em.archive.emStocktakingTask.filter.firstStocktakeTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'firstStocktakeTimeLteFilter',
        label: 'label.em.archive.emStocktakingTask.filter.firstStocktakeTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'finishStocktakeTimeRteFilter',
        label: 'label.em.archive.emStocktakingTask.filter.finishStocktakeTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'finishStocktakeTimeLteFilter',
        label: 'label.em.archive.emStocktakingTask.filter.finishStocktakeTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    }
];

const qualityFilterConfigs = [
    {
        key: 'taskCodeFilter',
        label: 'label.em.archive.emStocktakingTask.filter.taskCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'taskHandlerIdFilter',
        label: 'label.em.archive.emStocktakingTask.filter.taskHandlerId',
        disabled: false,
        form: {
            type: 'entityModalMultipleSelect',
            modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
        }
    },
    {
        key: 'stocktakeStatusFilter',
        label: 'label.em.archive.emStocktakingTask.filter.stocktakeStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
            ,options: [
                { value: '0', text: '未盘点' },
                { value: '1', text: '盘点中' },
                { value: '2', text: '部分盘点' },
                { value: '3', text: '盘点成功完成' },
                { value: '4', text: '补盘点成功完成' },
                { value: '5', text: '盘点异常完成' }
            ]
        }
    },
    {
        key: 'taskCreatedTimeRteFilter',
        label: 'label.em.archive.emStocktakingTask.filter.taskCreatedTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'taskCreatedTimeLteFilter',
        label: 'label.em.archive.emStocktakingTask.filter.taskCreatedTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'firstStocktakeTimeRteFilter',
        label: 'label.em.archive.emStocktakingTask.filter.firstStocktakeTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'firstStocktakeTimeLteFilter',
        label: 'label.em.archive.emStocktakingTask.filter.firstStocktakeTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'finishStocktakeTimeRteFilter',
        label: 'label.em.archive.emStocktakingTask.filter.finishStocktakeTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'finishStocktakeTimeLteFilter',
        label: 'label.em.archive.emStocktakingTask.filter.finishStocktakeTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'taskCode',
        label: 'label.em.archive.emStocktakingTask.entity.taskCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'taskBusinessType',
        label: 'label.em.archive.emStocktakingTask.entity.taskBusinessType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '工具/刀具'},
                {value: '2', text: '吊索具'},
                {value: '3', text: '固定资产'},
                {value: '4', text: '工装'}, {value: '5', text: '量器具'}
            ]
        }
    },
    {
        key: 'taskHandlerId',
        label: 'label.em.archive.emStocktakingTask.entity.taskHandlerId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'stocktakeStatus',
        label: 'label.em.archive.emStocktakingTask.entity.stocktakeStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: '未盘点'},
                {value: '1', text: '盘点中'},
                {value: '2', text: '部分盘点'},
                {value: '3', text: '盘点成功完成'},
                {value: '4', text: '补盘点成功完成'},
                {value: '5', text: '盘点异常完成'}
            ]
        }
    },
    {
        key: 'taskCreatedTime',
        label: 'label.em.archive.emStocktakingTask.entity.taskCreatedTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'firstStocktakeTime',
        label: 'label.em.archive.emStocktakingTask.entity.firstStocktakeTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'finishStocktakeTime',
        label: 'label.em.archive.emStocktakingTask.entity.finishStocktakeTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.em.archive.emStocktakingTask.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    EmStocktakingTask, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs,qualityFilterConfigs

}
